"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_1 = require("gatsby");
const gatsby_2 = require("gatsby");
const layout_1 = require("../components/layout");
const React = require("react");
const TechnologyTemplate = ({ data, }) => {
    const { markdownRemark, tags } = data;
    if (!markdownRemark || !markdownRemark.frontmatter)
        return React.createElement("div", null);
    const { frontmatter, html } = markdownRemark;
    if (frontmatter.parent && typeof (window) !== 'undefined') {
        gatsby_2.navigate(`/technologies/${frontmatter.parent}`);
        return (React.createElement("div", null));
    }
    return (React.createElement(layout_1.default, null,
        React.createElement("div", { className: "project-container" },
            React.createElement("div", { className: "project" },
                React.createElement("h1", null, frontmatter.title),
                tags.nodes.length > 0 && React.createElement("div", { className: "tags-list" },
                    "See also:",
                    " ",
                    (tags.nodes || []).map(tag => React.createElement("span", { key: tag.fields.tag },
                        React.createElement(gatsby_2.Link, { to: tag.fields.slug }, tag.frontmatter.title)))),
                React.createElement("div", { className: "project-content", dangerouslySetInnerHTML: { __html: html || '' } })))));
};
exports.pageQuery = gatsby_1.graphql `
  query techPage ($path: String!, $tags: [String]) {
    markdownRemark(fields: { slug: { eq: $path } }) {
      html
      frontmatter {
        title
        tags
        competence
        parent
      }
    }
    tags: allMarkdownRemark(filter: {
      fields: { tag: { in: $tags } }
    }) {
    	nodes {
        fields {
          slug
          tag
        }
        frontmatter {
          title
        }
      }
    }
  }
`;
exports.default = TechnologyTemplate;
